import { FormControl, TextField } from "@material-ui/core";
import React from "react";

const TextInput = (
    {maxLength, errorMessage, ...props}
) => {

    return (
        <FormControl fullWidth>
            <TextField
                variant="outlined"
                {...props}
                inputProps={{ maxLength: maxLength ? maxLength : 9999 }}
            />
            <span>{errorMessage}</span>
        </FormControl>
    )
}
export default TextInput;